import { PartEngineeringType } from '@prisma/client';
import { stringToEnum } from '@snap-types/models/common';
import { z } from 'zod/v4';

import { VisualWorkOrderType, visualWorkOrderTypeSchema } from './enums';
import { visToSnapWorkOrderType } from './transform-visual-to-snap';

// The fields type, base, lot, split, and sub together form the
// composite key that relates work orders to other tables, such as
// operations, document->workorder references, etc
export const visualWorkorderCompositeIdColumns = {
  type: visualWorkOrderTypeSchema,
  base_id: z.string(),
  lot_id: z.string(),
  split_id: z.string(),
  sub_id: z.string(),
};

export const visualWorkorderCompositeIdSchema = z.object(
  visualWorkorderCompositeIdColumns,
);

export type VisualWorkorderCompositeId = z.output<
  typeof visualWorkorderCompositeIdSchema
>;

export const workorderCompositeIdColumns = {
  type: stringToEnum(PartEngineeringType),
  baseId: z.string(),
  lotId: z.string(),
  splitId: z.string(),
  subId: z.string(),
};

export const workorderCompositeIdSchema = z.object(workorderCompositeIdColumns);

export type WorkorderCompositeId = z.output<typeof workorderCompositeIdSchema>;

export function visToSnapWorkorderCompositeId(
  workorderCompositeId: VisualWorkorderCompositeId,
): WorkorderCompositeId {
  return {
    baseId: workorderCompositeId.base_id,
    lotId: workorderCompositeId.lot_id,
    splitId: workorderCompositeId.split_id,
    subId: workorderCompositeId.sub_id,
    type: visToSnapWorkOrderType[workorderCompositeId.type],
  };
}

export function snapToVisWorkorderCompositeId(
  workorderCompositeId: WorkorderCompositeId,
): VisualWorkorderCompositeId {
  return {
    base_id: workorderCompositeId.baseId,
    lot_id: workorderCompositeId.lotId,
    split_id: workorderCompositeId.splitId,
    sub_id: workorderCompositeId.subId,
    type: workorderCompositeId.type as VisualWorkOrderType,
  };
}
